import { TApplicationState } from '../../types/redux';

export const reliabilitySelector = (state: TApplicationState) => state.reliabilityState.reliability;
